import { render, staticRenderFns } from "./AsSpeedDialogForAdmin.vue?vue&type=template&id=bf4bbed2&scoped=true"
import script from "./AsSpeedDialogForAdmin.vue?vue&type=script&lang=js"
export * from "./AsSpeedDialogForAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4bbed2",
  null
  
)

export default component.exports